
import { useState } from 'react';

export default function ContactForm() {
  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    telephone: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const form = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        form.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d34kuo16e2tdlv1m2hng', {
        method: 'POST',
        body: form
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ nom: '', email: '', telephone: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact-form" className="py-20 bg-black relative">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl lg:text-5xl font-bold text-white mb-6">
              Réservez votre <span className="text-[#9EFD38]">rendez-vous gratuit</span> dès aujourd&apos;hui
            </h2>
            <p className="text-lg md:text-xl text-gray-300">
              Découvrez comment augmenter vos ventes de +20 à +40% sans investir 1€
            </p>
          </div>
          
          <div className="bg-white rounded-3xl p-6 md:p-8 lg:p-12 relative border-4 border-[#9EFD38] shadow-2xl">
            {/* Badge sur le formulaire - repositionné encore plus haut pour éviter tout chevauchement */}
            <div className="absolute -top-8 md:-top-4 left-1/2 transform -translate-x-1/2 md:left-auto md:right-8 md:transform-none bg-[#9EFD38] text-black px-4 py-2 rounded-full font-bold text-sm flex items-center shadow-lg border-2 border-black">
              <i className="ri-gift-line mr-2"></i>
              Consultation gratuite
            </div>

            <form id="virtualeat-contact" onSubmit={handleSubmit} data-readdy-form>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <div>
                  <label htmlFor="nom" className="block text-gray-700 font-semibold mb-2">
                    Nom complet *
                  </label>
                  <input
                    type="text"
                    id="nom"
                    name="nom"
                    value={formData.nom}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-[#9EFD38] focus:border-[#9EFD38] text-sm"
                    placeholder="Votre nom et prénom"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-gray-700 font-semibold mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-[#9EFD38] focus:border-[#9EFD38] text-sm"
                    placeholder="votre@email.com"
                  />
                </div>
                
                <div>
                  <label htmlFor="telephone" className="block text-gray-700 font-semibold mb-2">
                    Téléphone *
                  </label>
                  <input
                    type="tel"
                    id="telephone"
                    name="telephone"
                    value={formData.telephone}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-[#9EFD38] focus:border-[#9EFD38] text-sm"
                    placeholder="+32 XXX XXX XXX"
                  />
                </div>
              </div>

              <div className="text-center">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-[#9EFD38] hover:bg-[#8AE832] text-black font-bold text-xs md:text-lg px-4 md:px-12 py-2 md:py-4 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer border-4 border-black mx-auto block max-w-[280px] md:max-w-none"
                >
                  {isSubmitting ? (
                    <>
                      <i className="ri-loader-4-line animate-spin mr-1 md:mr-2"></i>
                      <span className="whitespace-nowrap text-xs md:text-base">Envoi en cours...</span>
                    </>
                  ) : (
                    <span className="whitespace-nowrap text-xs md:text-base">👉 Je veux augmenter mes ventes !</span>
                  )}
                </button>
                
                <div className="mt-4 text-center">
                  <p className="text-gray-500 text-sm">
                    🚀 Réservation 100% gratuite – Aucun engagement.
                  </p>
                </div>
              </div>
              
              {submitStatus === 'success' && (
                <div className="mt-6 p-4 bg-green-100 border border-green-300 rounded-xl text-green-700 text-center">
                  <i className="ri-check-circle-line text-xl mr-2"></i>
                  Merci ! Nous vous recontacterons sous 24h pour programmer votre rendez-vous gratuit.
                </div>
              )}
              
              {submitStatus === 'error' && (
                <div className="mt-6 p-4 bg-red-100 border border-red-300 rounded-xl text-red-700 text-center">
                  <i className="ri-error-warning-line text-xl mr-2"></i>
                  Une erreur s&apos;est produite. Veuillez réessayer ou nous contacter directement.
                </div>
              )}
            </form>
          </div>
          
          <div className="text-center mt-8">
            <p className="text-gray-300 text-base md:text-lg">
              Nous vous recontacterons sous 24h maximum
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
